import { render, staticRenderFns } from "./CustomerContractPlanHistoryValuesTable.vue?vue&type=template&id=1081c8a4"
import script from "./CustomerContractPlanHistoryValuesTable.vue?vue&type=script&lang=js"
export * from "./CustomerContractPlanHistoryValuesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports